import initialState from "./initial.value";

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case "User_data":
      return { ...state, user_data: action.payload };
    case "Bearer_token":
      return { ...state, bearer_token: action.payload };
    case "Current_Store":
      return { ...state, current_store: action.payload };
    case "Current_Cart":
      return { ...state, current_cart: action.payload };
    case "Rolesandpermission_data":
      return { ...state, rolesandpermission_data: action.payload };
    case "Userpermission_data":
      return { ...state, userpermission_data: action.payload };
    case "Layoutstyle_data":
      return { ...state, layoutstyledata: action.payload };
    default:
      return state;
  }
};

export default rootReducer;
